import { Action, Dispatch, Middleware, MiddlewareAPI } from 'redux'
import { logoutAction } from '../session/authentication/actions'
import { LOGOUT, SET_TOKEN } from '../session/authentication/types'
import { Store } from '../types'
import { REQUEST } from './types'
import { getJwtError } from '../../utils/jwt'

const token: Middleware =
  ({ dispatch, getState }: MiddlewareAPI) =>
  (next: Dispatch) =>
  (action: Action) => {
    const store: Store = getState()
    const skip = [LOGOUT, REQUEST, SET_TOKEN]

    const t = store?.session?.authentication?.token

    if (!skip.includes(action.type) && t && getJwtError(t)) {
      dispatch(logoutAction())
    }
    return next(action)
  }

export default token
